import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { patchInsuranceType } from "../../store/insuranceType/actions";
export var useInsuranceTypePatch = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responsePatchInsuranceType: state.InsuranceType.responsePatchInsuranceType,
        errorPatchInsuranceType: state.InsuranceType.errorPatchInsuranceType,
        loadingPatchInsuranceType: state.InsuranceType.loadingPatchInsuranceType,
    }); }), responsePatchInsuranceType = _a.responsePatchInsuranceType, errorPatchInsuranceType = _a.errorPatchInsuranceType, loadingPatchInsuranceType = _a.loadingPatchInsuranceType;
    useEffect(function () {
        if (trigger) {
            dispatch(patchInsuranceType({
                description: body.description,
            }, body.id));
        }
    }, [trigger]);
    return {
        responsePatchInsuranceType: responsePatchInsuranceType,
        errorPatchInsuranceType: errorPatchInsuranceType,
        loadingPatchInsuranceType: loadingPatchInsuranceType,
    };
};
